import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["title", "description", "imageUrl", "collectionSlug", "cards"];
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { EcosystemListingStub } from 'trellis-ecosystem';
import { CollectionCard } from './CollectionCard';
import { useHistory } from 'react-router-dom';
import { Paths } from '../constants/paths';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CollectionSection(_ref) {
  let {
      title,
      description,
      imageUrl,
      collectionSlug,
      cards
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const history = useHistory();
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "1000",
    children: /*#__PURE__*/_jsxs(Grid, Object.assign({}, restProps, {
      children: [/*#__PURE__*/_jsx(GridItem, {
        size: {
          xs: 12,
          lg: 6
        },
        children: /*#__PURE__*/_jsx(CollectionCard, {
          name: title,
          description: description,
          imageSrc: imageUrl !== null && imageUrl !== void 0 ? imageUrl : '',
          blockSize: "100%",
          use: "on-dark",
          onClick: () => {
            history.push(Paths.FEATURED_COLLECTION.replace(':collectionSlug', collectionSlug));
            window.scrollTo(0, 0);
          }
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        paddingBlockEnd: "400",
        size: {
          xs: 12,
          lg: 0
        }
      }), /*#__PURE__*/_jsx(GridItem, {
        size: {
          xs: 12,
          lg: 6
        },
        children: /*#__PURE__*/_jsx(Flex, {
          blockSize: "100%",
          alignItems: "stretch",
          children: /*#__PURE__*/_jsx(Grid, {
            children: cards.map(item => {
              var _item$imageSrcSmall;
              return /*#__PURE__*/_jsx(GridItem, {
                padding: "300",
                size: {
                  xs: 6,
                  md: 4,
                  lg: 6
                },
                children: /*#__PURE__*/_jsx(Flex, {
                  alignItems: "center",
                  blockSize: "100%",
                  children: /*#__PURE__*/_jsx(EcosystemListingStub, {
                    name: item.name,
                    imageSrc: (_item$imageSrcSmall = item.imageSrcSmall) !== null && _item$imageSrcSmall !== void 0 ? _item$imageSrcSmall : '',
                    productType: "APP",
                    listingHref: item.listingHref,
                    providerName: item.providerName
                  })
                })
              }, item.name);
            })
          })
        })
      })]
    }))
  });
}